import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReportsComponent } from './reports.component';
import { ReportsResolve } from './reports.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/reports',
        component: ReportsComponent,
        resolve: {
          portal: ReportsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class ReportsRoutingModule {}
